const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CompleteAndConfirmQuery: any = {
    GetRequestData: Backofficebff + '/v1/completeandconfirmrequest/get',
};
